import { NavLink } from "react-router-dom";
import { stepLabel, stepPath, type Progress, type StepId } from "../lib/setup.ts";

const ITEMS: StepId[] = ["create", "knowledge", "answers", "test", "look", "install"];

export function Steps({ agentId, progress, current }: { agentId: string; progress: Progress; current?: StepId }) {
  return (
    <nav className="steps" aria-label="Setup steps">
      <ol>
        {ITEMS.map((step, index) => {
          const done = progress[step];
          const active = current === step;
          return (
            <li key={step} className={active ? "current" : done ? "done" : ""}>
              <NavLink to={stepPath(agentId, step)} aria-current={active ? "step" : undefined}>
                <span>{done && !active ? "✓" : index + 1}</span>
                {stepLabel(step)}
                {step === "knowledge" && progress.reading && !done ? <em>Reading…</em> : null}
              </NavLink>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
